import { render, staticRenderFns } from "./EditBudgetExpense.vue?vue&type=template&id=3f968947&scoped=true&"
import script from "./EditBudgetExpense.vue?vue&type=script&lang=js&"
export * from "./EditBudgetExpense.vue?vue&type=script&lang=js&"
import style0 from "./EditBudgetExpense.vue?vue&type=style&index=0&id=3f968947&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f968947",
  null
  
)

export default component.exports